import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';

import * as forge from 'node-forge'
import reg from '@/f1/reg'
import codes from '@/f1/codes'
import 'vue-select/dist/vue-select.css';
import _ from 'lodash'
import Language from './language';
import logList from '../../log/Login.i18n'

//restful api
import { management } from '@/f1/service/api';

//i18n_data
import i18n_toast from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_model = () => ({ is_alive: true, permissions: 'User' });

export default {
  components: { cSwitch, vSelect, Language, logList },
  data : () => ({
    codes,
    confirm: false,
    add: false,
    lock: true,
    groups: [],
    levels: ['User', 'Monitor', 'Billing'],
    model : default_model(),
    allowed: false,
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false, min_length : 10 },
    per_check : 0,
    count : 0,
    perID : 0,
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr ? this.model.last_addr : '-'}`; }
  },
  methods: {
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new__password && reg.reg_number.test(this.model.new__password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new__password && reg.reg_alphabat_upper.test(this.model.new__password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new__password && reg.reg_alphabat_lower.test(this.model.new__password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new__password && reg.reg_spacial.test(this.model.new__password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new__password && this.model.new__password.length > this.password_meter.min_length) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    // validate_ip() {
    //   return;
    //   let ips = (this.model.restrict_addr || '').split('\n');
    //   let rv = [];
    //   _.forEach(ips, ip => { if(reg.ip4_range.test(ip)) { rv.push(ip); } })
    // },
    cancel() { this.$router.replace({ name: 'user', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'user', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        // await api.member.Manager_Call('user', 'delete', {id : this.model.id});
        await management.user.delete({id : this.model.id});
        this.$parent.$emit('refresh'); this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.list(); },
    list() { this.$router.push({ name: 'user'}); },
    async save() {
      if(!(this.model.username || '').trim()) {
        // return this.$toastr.e('E-mail(ID) Required.');
        return this.$toastr.e(`${i18n_toast._i18n_warning.email_check[this.i18n]}`);
      }
      // if(!reg.email.test(this.model.username)) { return this.$toastr.e('올바른 이메일 형식이 아닙니다.');}

      //permission - owner 중복 생성 불가 조건
      //해당 조건은 백단 02 버전 이후에 적용되어있습니다.
      if(this.model.permissions == 'Owner' && this.per_check > 1 || this.model.permissions == 'Owner' && this.per_check == 1 && this.perID != this.model.id){
        this.$parent.$emit('refresh'); return this.$toastr.e(`${i18n_toast._i18n_error.permission_check[this.i18n]}`);
      }

      if(!this.model.id && !this.model.new__password) {
        // return this.$toastr.e('Password Required.');
        return this.$toastr.e(i18n_data._i18n_error.password[this.i18n]);
      }
      if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) {
        // return this.$toastr.e('Password and password confirmation do not match');
        return this.$toastr.e(`${i18n_toast._i18n_error.new_password_repeat[this.i18n]}`);
      }
      if(this.model.new__password) {
        // 그룹의 패스워드 정책 확인
        let policy_count = -3
        if(this.model.group.security_policy && this.model.group.security_policy.password_use_number) { policy_count +=1 }
        if(this.model.group.security_policy && this.model.group.security_policy.password_use_spacial) { policy_count +=1 }
        if(this.model.group.security_policy && this.model.group.security_policy.password_use_alphabet) { policy_count +=1 }

        // 그룹 정책에서 최소한의 정책이 없을 경우, 시스템 정책을 따른다
        if(policy_count < 0) {
          var rs = this.password_policy('all')
          if(rs.is_error) {
            var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
            // return this.$toastr.e(`Please check password policy [${msg}]`);
            return this.$toastr.e(`${i18n_data._i18n_warning.newPassword[this.i18n]} [${msg}]`);
          }
        } else {
          if(this.model.group && this.model.group.security_policy) {
            if(this.model.group.security_policy.password_use_alphabet && (!this.password_policy('uppercase') && !this.password_policy('lowercase'))) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_2[this.i18n]}`) }
            if(this.model.group.security_policy.password_use_spacial && !this.password_policy('spacial')) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_3[this.i18n]}`) }
            if(this.model.group.security_policy.password_use_number && !this.password_policy('number')) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_4[this.i18n]}`) }
            if(this.model.group.security_policy.password_min_len > 0 && !this.password_policy('length')) { return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_6[this.i18n]}` + this.password_meter.min_length) }
          } else {return this.$toastr.e(`${i18n_data._i18n_warning.newPassword_5[this.i18n]}`)}
        }

        if(this.model.new__password != this.model.new_password_repeat) {
          // return this.$toastr.e("The password verification entered is not the same")
          return this.$toastr.e(`${i18n_toast._i18n_error.new_password_repeat_2[this.i18n]}`)
        }

        this.model.new_password = forge.sha256.create().update(this.model.new__password).digest().toHex();
      }

      // 아래 코드는 의미 없음, 해시하고 검사하기 때문에, @check 해당 코드는 주석 처리함
      // var patt_4num1 = /(\w)\1\1\1/; // 같은 영문자&숫자 연속 4번 정규식
      // var patt_4num2 = /([\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"])\1\1\1/; // 같은 특수문자 연속 4번 정규식
      // var patt_4num3 = /([가-힣ㄱ-ㅎㅏ-ㅣ\x20])\1\1\1/; // 같은 한글 연속 4번 정규식
      // var patt_cont = /(0123)|(1234)|(2345)|(3456)|(4567)|(5678)|(6789)|(7890)/; // 연속된 숫자 정규식
      // if(patt_4num1.test(this.model.new__password) || patt_4num2.test(this.model.new__password) || patt_4num3.test(this.new__password) || patt_cont.test(this.new__password)){
      //   return this.$toastr.e("You cannot use consecutive characters or numbers")
      // }
      let model = this.model
      if(this.model.allow_ip_list) {
        model.allow_ip = _.uniq(_.compact(this.model.allow_ip_list.replace(/,/gm, '').split("\n")));
        // b-form-textarea has bug, can not bind model so rirect update
        this.model.allow_ip_list = _.join(model.allow_ip, '\n')
        this.$refs.allow_ip_list.localValue = _.join(model.allow_ip, '\n')
      } else { model.allow_ip = "" }
      // this.model.is_del = !this.model.allowed;

      try {
        this.model.group_id = auth.profile.group_id;
        // let rs = await api.member.Manager_Call('user', this.model.id ? 'update' : 'insert', this.model);
        let check_id = this.model.id ? `${await management.user.update(this.model)}` : `${await management.user.insert(this.model)}`;

        let rs = check_id;
        console.info(rs)
        if(!rs.error) {
          this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`);
        } else {
          this.$toastr.e(`${i18n_data._i18n_error.save_failed[this.i18n]}`);
        }
        this.list();
        this.$parent.$emit('refresh');
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText); this.list();  }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] user.detail', 'load item', id);
      if(id === 'add') {
        this.add = true; this.lock = false; this.model = default_model();
        // let rs = await api.member.Manager_Call('group', 'detail', {id : auth.profile.group_id});
        let rs = await management.group.detail({id : auth.profile.group_id});
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }
        this.model = Object.assign({}, this.model, { group : rs.body })
        return;
      }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try {
        // let rs = await api.member.Manager_Call('user', 'detail', {id : id});
        let rs = await management.user.detail({id : id});
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }
        this.model = rs.body
        this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")
        if(this.model.group && this.model.group.security_policy) {
          this.password_meter.min_length = this.model.group.security_policy.password_min_len < 10 ? this.password_meter.min_length : this.model.group.security_policy.password_min_len
        }
      }
      catch(e) { console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data || e); this.list(); }

      // api.member.Manager({ target : 'log.login', cmd : 'list.user', body : { ts : new Date().getTime() } }).then(rs => {
      //   if(!rs.body || rs.body.length < 1) { return; }

      // }).catch(e => { console.log('log.login', e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});
    },
    //owner 계정 유무 확인
    async permission_check(){
      var search = { limit: 10, offset: 0, body: { and: [{name: 'group_id', value : auth.profile.group_id, op : '='}, {name : 'is_del' , value: false, op : '='}], or: [], sort: [] } }
      let rs = await management.user.list(search);

      for(let i = 0; i< rs.count; i++){
        if(rs.body[i].permissions == 'Owner'){
          this.count = this.count + 1;
          if(this.count == 1){
            this.perID = rs.body[i].id
          }
        }
      }
      this.per_check = this.count
      return this.per_check
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('[vue] user.detail', 'created'); },
  destroyed() { console.log('[vue] user.detail', 'destroyed'); },
  mounted() {
    console.log('[vue] user.detail', 'mounted');
    // this.levels = _.take(this.levels, _.indexOf(this.levels, auth.profile.level) + 1);
    this.get(this.$route.params);
    this.permission_check();
  },
}
